/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_NoteInputs */

const tr_servis_s4_note = /** @type {(inputs: Servis_S4_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta döneminde SLA garanti edilmemektedir; taahhütler platform genel kullanıma açıldıktan sonra yürürlüğe girer.`)
};

const en_servis_s4_note = /** @type {(inputs: Servis_S4_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The SLA is not guaranteed during the beta period; the commitments take effect after the platform becomes generally available.`)
};

const de_servis_s4_note = /** @type {(inputs: Servis_S4_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Während der Beta-Phase wird das SLA nicht garantiert; die Zusagen treten in Kraft, nachdem die Plattform allgemein verfügbar ist.`)
};

const ru_servis_s4_note = /** @type {(inputs: Servis_S4_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В период бета-тестирования SLA не гарантируется; обязательства вступают в силу после общего запуска платформы.`)
};

/**
* | output |
* | --- |
* | "The SLA is not guaranteed during the beta period; the commitments take effect after the platform becomes generally available." |
*
* @param {Servis_S4_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_note = /** @type {((inputs?: Servis_S4_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_note(inputs)
	if (locale === "de") return de_servis_s4_note(inputs)
	if (locale === "ru") return ru_servis_s4_note(inputs)
	return tr_servis_s4_note(inputs)
});